import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ComponentAbstract } from '@app/components/abstract/component.abstract';
import { ModalData } from '@shared/interfaces/modal-data';

@Component({
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class InfoModalComponent extends ComponentAbstract {
  protected cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  public dialogRef: MatDialogRef<InfoModalComponent> = inject(MatDialogRef);
  public data: ModalData = inject(MAT_DIALOG_DATA);

  constructor() {
    super(inject(ChangeDetectorRef));
  }

  confirm() {
    this.dialogRef.close();
  }
}
